/// <amd-module name="DirtyDocumentServices/Redux/DirtyDocumentsActions" />
import { Action } from "redux/Utils/ActionHelper";

export const enum MetaTypes {
    SET_DOCUMENT_DIRTY = "SET_DOCUMENT_DIRTY",
    CLEAR_DOCUMENT_DIRTY = "CLEAR_DOCUMENT_DIRTY"
}

/**
 * Creates an action which indicate that given set of document ids are dirty
 * Note: This does not support ref counting, we can do it later if needed
 */
export function setDocumentDirty<T, A extends Action<T>>(action: A, ids: (string | number)[]): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.SET_DOCUMENT_DIRTY] = { ids };
    return action;
}

/**
 * Creates an action which indicate that given set of document ids are not dirty
 */
export function clearDocumentDirty<T, A extends Action<T>>(action: A, ids: (string | number)[]): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.CLEAR_DOCUMENT_DIRTY] = { ids };
    return action;
}

export interface DirtyDocumentAction extends Action<any> {
    meta: {
        [MetaTypes.SET_DOCUMENT_DIRTY]?: {
            ids: string[];
        };
        [MetaTypes.CLEAR_DOCUMENT_DIRTY]?: {
            ids: string[];
        };
    };
}
